import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {DialogService} from "ng2-bootstrap-modal";
import {CoinCandlestickConditionService} from "../../../_services/coin-candlestick-condition.service";
import {CoinConfigService} from "../../../_services/coinconfig.service";
import {Observable} from "rxjs/Observable";
import {Subject} from "rxjs/Subject";
import {PopupCoinCandlestickConditionComponent} from "../popup-coin-candlestick-condition/popup-coin-candlestick-condition.component";
import {DataTableDirective} from "angular-datatables";
import {LineBotService} from '../../../_services/line-bot.service';

@Component({
    selector: 'app-coin-candlestick-condition',
    templateUrl: './coin-candlestick-condition.component.html',
    styleUrls: ['./coin-candlestick-condition.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class CoinCandlestickConditionComponent implements OnInit {

    callback: any = {};
    parameters: any = {};
    dtOptions: DataTables.Settings = {};
    coinName: string;
    pairId: string;
    markets: Observable<any[]>;
    pairs: Observable<any[]>;
    dtTrigger: Subject<any> = new Subject();
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;
    objPopUp: any;
    marketId: string;
    line_bot_id: string;
    lineBotAlls: Observable<any[]>;

    constructor(private coinConfigService: CoinConfigService,
                private dialogService: DialogService,
                private coinCondition: CoinCandlestickConditionService,
                private lineBotService: LineBotService,
    ) {
        this.markets = this.coinConfigService.getMarkets();
        this.lineBotAlls =  this.lineBotService.getLineBot();
    }

    ngOnInit() {
        //pairs
        this.pairs = this.coinConfigService.getPairs();
        this.tableSort(this.markets);
    }

    tableSort(dataMarkets: any) {
        let self = this;
        this.dtOptions = {
            language: {
                emptyTable: "データが存在しません"
            },
            order: [[0, "desc"]],
            searching: false,
            lengthChange: false,
            serverSide: true,
            pageLength: 15,
            ajax: function (parameters, callback, settings) {
                parameters["search"]["value"] = self.coinName || '';
                parameters["search"]["pair"] = self.pairId || '';

                self.lineBotAlls.subscribe(dataLineBot => {
                    if (dataLineBot && dataLineBot.constructor === Array && dataLineBot.length) {
                        dataMarkets.subscribe(dataMarket => {
                            parameters["search"]["market"] = self.marketId || dataMarket[0].id;
                            parameters["search"]["line_bot_id"] = self.line_bot_id || dataLineBot[0].id;

                            //assign parameters object
                            self.parameters = parameters;
                            //assign callback object
                            self.callback = callback;

                            self.coinCondition.gets(parameters).subscribe(result => {
                                callback({
                                    draw: parameters['draw'],
                                    data: result.data,
                                    recordsTotal: result.data.length,
                                    recordsFiltered: result.recordsTotal
                                });
                            });
                        });
                    }
                });
            },
            columns: [
                {
                    data: "coin_name",
                    name: "coin_name",
                    className: "all text-justify",
                }, {
                    data: "name_cryptocurrency",
                    name: "cryptocurrency",
                    className: "all text-justify"
                }, {
                    data: "current_trend_type",
                    name: "current_trend_type",
                    className: "all text-justify",
                    width: '80px',
                    render: function (currentTrend) {
                        if (currentTrend == -1) {
                            return '<i class="fa fa-long-arrow-down color-red"></i>';
                        } else if(currentTrend == 1) {
                            return '<i class="fa fa-long-arrow-up color-green"></i>';
                        } else  {
                            return '';
                        }
                    }
                }, {
                    data: "name_condition_buy_1",
                    name: "condition_buy_1",
                    className: "text-right",
                    orderable: false
                }, {
                    data: "name_condition_sell_1",
                    name: "name_condition_sell_1",
                    className: "text-right",
                    orderable: false
                }, {
                    data: "name_condition_buy_2",
                    name: "name_condition_buy_2",
                    className: "text-right",
                    orderable: false,
                }, {
                    data: "name_condition_sell_2",
                    name: "name_condition_sell_2",
                    className: "text-right",
                    orderable: false
                }, {
                    data: function (d) {
                        return `<button class="btn btn-sm btn-edit btn-candlestick-condition">編集</button>`;
                    },
                    width: '120px',
                    className: "all text-center",
                    orderable: false
                }
            ],
            rowCallback: (row: Node, data: any[] | Object, index: number) => {
                const self = this;
                $('.btn-candlestick-condition', row).bind('click', () => {
                    self.openModalEditCoin(data);
                });

                let btn_edit = $(row).find('td').find('.btn-edit');
                btn_edit.css({
                    'background-color': 'deepskyblue',
                    'color': '#fff'
                });
                btn_edit.mouseover(function () {
                    btn_edit.css('opacity', '0.9');
                });
                btn_edit.mouseout(function () {
                    btn_edit.css('opacity', '1');
                });

                return row;
            }
        };
    }

    onChangeMarkets(event) {
        this.marketId = event.target.value;
        this.renderDataTable();
    }

    onChangeLineBot(event) {
        this.line_bot_id = event.target.value;
        this.renderDataTable();
    }

    onChange(event) {
        this.pairId = event.target.value;
        this.renderDataTable();
    }

    doSearch(event) {
        this.coinName = event;
        let self = this;
        let delayTimer = setTimeout(function () {
            self.renderDataTable();
            clearTimeout(delayTimer);
        }, 600);
    };

    renderDataTable(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }

    openModalEditCoin(dataObject) {
        let self = this;
        this.coinCondition.getConditions({marketID: dataObject.market_id}).subscribe(res => {
            if (Object.keys(res).length) {
                self.objPopUp = {
                    currentConditionOneBuy: dataObject.condition_buy_1 + '',
                    currentConditionOneSell: dataObject.condition_sell_1 + '',
                    currentConditionTwoBuy: dataObject.condition_buy_2 + '',
                    currentConditionTwoSell: dataObject.condition_sell_2 + '',
                    titlePopup: dataObject.name_market_id + '取引所での' + dataObject.coin_name + "/" + dataObject.name_cryptocurrency + 'のcandlestick条件のコインを編集する。',
                    coinConditionID: dataObject.coin_condition_id,
                    marketID: dataObject.market_id,
                    configCoinConditionsOne: res.condition_1,
                    configCoinConditionsTwo: res.condition_2,
                    data: dataObject
                };

                this.dialogService.addDialog(PopupCoinCandlestickConditionComponent, self.objPopUp)
                    .subscribe((isAccess) => {
                        if (isAccess) {
                            this.loadCurrentPage();
                        }
                    });
            }
        });
    }

    loadCurrentPage() {
        //get parameters and retrive result of current page
        this.coinCondition.gets(this.parameters).subscribe(result => {
            this.callback({
                draw: this.parameters['draw'],
                data: result.data,
                recordsTotal: result.data.length,
                recordsFiltered: result.recordsTotal
            });
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/coin-candlestick-condition/coin-candlestick-condition/coin-candlestick-condition.component.ts